<template>
  <div class="column content-box page_container">
    <nav>
        <div class="toolbar">
            <div class="user_select">
                <MultiselectDropdown
                    :label="$t('UPCOMMING_CALENDAR.TOOLBAR.USER.LABEL')"
                >
                    <multiselect
                        class="column small-12"
                        v-model="selectedUsers"
                        :options="formattedAgents"
                        track-by="id"
                        label="available_name"
                        :multiple="true"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :placeholder="$t('UPCOMMING_CALENDAR.TOOLBAR.USER.PLACEHOLDER')"
                        selected-label
                        :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
                        :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
                        @select="onUserSelect"
                        @remove="onUserRemove"
                    />
                </MultiselectDropdown>
            </div>
        </div>
    </nav>
    <section v-if="!uiFlagsAgents.isFetching && currentUser.id && isMounted">
        <CalendarView
            :events="meetings"
            @onDateChange="onDateChange"
            @onClickEvent="onOpenDetailsModal"
        />
    </section>
    <EventDetailsModal
        v-if="selectedEvent"
        :isOpen="isEventDetailsModalOpen"
        :event="selectedEvent"
        @onClose="onCloseDetailsModal"
    />
  </div>
</template>

<script>
import MultiselectDropdown from "components/ui/inputs/MultiselectDropdown.vue"
import CalendarView from "./CalendarVIew.vue"
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import helperMixin from 'shared/mixins/helperMixin';
import EventDetailsModal from "./EventDetailsModal.vue";


export default {
    components: {
        MultiselectDropdown,
        CalendarView,
        EventDetailsModal,
    }, mixins: [alertMixin,helperMixin],
    computed:{
        ...mapGetters({
            currentUser: 'getCurrentUser',
            meetings: "meetings/getMeetings",
            meta: "meetings/getMeta",
            uiFlags: "meetings/getUIFlags",
            uiFlagsAgents: "agents/getUIFlags",
            agents: "agents/getAgents",
        }),
        formattedAgents(){
            return this.agents.map(agent => ({
                ...agent,
                available_name: `#${agent.id} - ${agent.available_name}`,
            }));
        }
    },
    data() {
        return {
            selectedUsers: [],
            isEventDetailsModalOpen:false,
            selectedEvent: null,
            dates:{
                start_date: null,
                end_date: null,
            },
            isMounted:false,
        }
    },
    async mounted(){
        await this.$store.dispatch('agents/get').then(()=>{
            this.setInitialState();
        });
    },
    methods:{
        async setInitialState(){
            await this.$nextTick();
            // findthe current user and set active
            const currentUser = this.formattedAgents.find(agent => agent.id === this.currentUser.id);
            this.selectedUsers = [currentUser];
            this.fetchMeetings({user_id:currentUser.id});
            this.isMounted=true;
        },
        fetchMeetings(query){
            let prepareQuery = {
                // page: query.page ?? this.meta.currentPage,
                start_date : query.start_date ?? this.dates.start_date,
                end_date : query.end_date ?? this.dates.end_date,
                user_id: query.user_id ?? this.selectedUsers.map(el=>el.id).join(","),
            }
            if (!prepareQuery.start_date) {
                return
            }
            const {start_date,end_date} = this.formatStartEndDate(prepareQuery.start_date,prepareQuery.end_date);
            console.log({start_date,end_date});
            prepareQuery = {
                ...prepareQuery,
                start_date: start_date.split('T')[0],
                end_date: end_date.split('T')[0],
            }
            this.$store.dispatch('meetings/getMeetings',this.cleanObject(prepareQuery));
        },
        onDateChange({start_date,end_date}){
            this.dates = {start_date,end_date};
            this.fetchMeetings({start_date,end_date});
        },
        onOpenDetailsModal(event){
            console.log(event);
            this.selectedEvent = event;
            this.isEventDetailsModalOpen = true;
        },
        onCloseDetailsModal(){
            this.isEventDetailsModalOpen = false;
            this.selectedEvent = null;
        },
        onUserSelect(user){
            const user_ids = [...this.selectedUsers,user].map(el=>el.id).join(",")
            this.fetchMeetings({user_id:user_ids});
        },
        onUserRemove(user){
            const user_ids = this.selectedUsers.filter(el=>el.id !== user.id).map(el=>el.id).join(",")
            this.fetchMeetings({user_id:user_ids});
        },
        // end methods
    },
}
</script>

<style scoped lang="scss">
.toolbar{
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  .user_select{
    min-width: 200px;
  }
}
</style>